import React from 'react';
import { BookmarkIcon, DownloadIcon, SparklesIcon } from 'lucide-react';
interface AlgaCoffeeTranscriptWidgetProps {
  coffeeHost: string;
  coffeeTitle: string;
}
const AlgaCoffeeTranscriptWidget: React.FC<AlgaCoffeeTranscriptWidgetProps> = ({
  coffeeHost,
  coffeeTitle
}) => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-633">
      <div className="p-4 border-b border-gray-200 flex items-center" data-id="element-634">
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-custom-green to-emerald-600 flex items-center justify-center mr-3 shadow-sm" data-id="element-635">
          <SparklesIcon size={16} className="text-white" data-id="element-636" />
        </div>
        <div data-id="element-637">
          <h2 className="text-base font-semibold text-gray-800" data-id="element-638">
            Trascrizione completa
          </h2>
          <p className="text-xs text-gray-500" data-id="element-639">Powered by Greenback AI</p>
        </div>
      </div>
      <div className="p-4" data-id="element-640">
        <div className="space-y-4" data-id="element-641">
          <div className="flex items-center justify-between" data-id="element-642">
            <h4 className="text-sm font-medium text-gray-800" data-id="element-643">
              Conversazione registrata
            </h4>
            <div className="flex items-center space-x-2" data-id="element-644">
              <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-645">
                <BookmarkIcon size={16} className="text-gray-500" data-id="element-646" />
              </button>
              <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-647">
                <DownloadIcon size={16} className="text-gray-500" data-id="element-648" />
              </button>
            </div>
          </div>
          <div className="text-sm text-gray-600 max-h-60 overflow-y-auto border border-gray-200 rounded-lg p-3" data-id="element-649">
            <div className="space-y-3" data-id="element-650">
              <div data-id="element-651">
                <p className="font-medium" data-id="element-652">{coffeeHost} (14:02):</p>
                <p data-id="element-653">
                  Buongiorno a tutti e benvenuti a questo EIIS Coffee su{' '}
                  {coffeeTitle}. Sono molto felice di vedere così tanti
                  partecipanti interessati a questo argomento.
                </p>
              </div>
              <div data-id="element-654">
                <p className="font-medium" data-id="element-655">Edoardo Gatner (14:05):</p>
                <p data-id="element-656">
                  Grazie per l'organizzazione di questo evento. Vorrei sapere
                  quali sono secondo te le sfide principali nell'implementazione
                  di strategie ESG in aziende di medie dimensioni?
                </p>
              </div>
              <div data-id="element-657">
                <p className="font-medium" data-id="element-658">{coffeeHost} (14:07):</p>
                <p data-id="element-659">
                  Ottima domanda Edoardo. Le aziende di medie dimensioni spesso
                  affrontano sfide specifiche come risorse limitate, competenze
                  interne insufficienti e difficoltà nel misurare l'impatto
                  delle iniziative ESG...
                </p>
              </div>
              <div data-id="element-660">
                <p className="font-medium" data-id="element-661">Laura Bianchi (14:12):</p>
                <p data-id="element-662">
                  Dal mio punto di vista, un'altra sfida importante è
                  l'integrazione delle strategie ESG con gli obiettivi di
                  business esistenti. Spesso vengono visti come due percorsi
                  separati.
                </p>
              </div>
              <div data-id="element-663">
                <p className="font-medium" data-id="element-664">{coffeeHost} (14:15):</p>
                <p data-id="element-665">
                  Assolutamente d'accordo Laura. L'integrazione è fondamentale
                  per il successo a lungo termine...
                </p>
              </div>
            </div>
          </div>
          <div className="text-center text-xs text-gray-500" data-id="element-666">
            <a href="#" className="text-custom-green hover:underline" data-id="element-667">
              Visualizza trascrizione completa
            </a>
          </div>
        </div>
      </div>
    </div>;
};
export default AlgaCoffeeTranscriptWidget;